import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PinIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 1.36526C10.7614 1.36526 13 3.60384 13 6.36526C13 7.34755 12.4873 8.68923 11.5783 10.411C11.3598 10.8249 11.121 11.2542 10.865 11.6955C10.4183 12.4655 9.94095 13.2357 9.46365 13.9706C9.29659 14.2279 9.14132 14.4625 9.00171 14.6702L8.82279 14.9336C8.42524 15.5092 7.57476 15.5092 7.17721 14.9336L6.8536 14.4537L6.53635 13.9706C6.05905 13.2357 5.58169 12.4655 5.135 11.6955C4.87903 11.2542 4.6402 10.8249 4.42166 10.411C3.51272 8.68923 3 7.34755 3 6.36526C3 3.60384 5.23858 1.36526 8 1.36526ZM8 4.36526C6.89543 4.36526 6 5.26069 6 6.36526C6 7.46983 6.89543 8.36526 8 8.36526C9.10457 8.36526 10 7.46983 10 6.36526C10 5.26069 9.10457 4.36526 8 4.36526Z"
		/>
	</svg>
))
